function envList() {
    return [
        { id: '0', name: 'P1' },
        { id: '1', name: 'P2' },
        { id: '2', name: 'P3' },
        { id: '3', name: 'P4' }
    ]
}

function imgMessage() {
    return [
        { id: 1, name: require('../../assets/grey.png') },
        { id: 2, name: require('../../assets/grey_anime.gif') },
        { id: 3, name: require('../../assets/blue.png') },
        { id: 4, name: require('../../assets/blue_anime.gif') },
        { id: 5, name: require('../../assets/red.png') },
        { id: 6, name: require('../../assets/red_anime.gif') },
        { id: 7, name: require('../../assets/yellow.png') },
        { id: 8, name: require('../../assets/yellow_anime.gif') }
    ]
}

export {
    envList,
    imgMessage
}